// extracted by mini-css-extract-plugin
module.exports = {"smallThumb":"ImageSlider_smallThumb__3TCSp","selected":"ImageSlider_selected__yj6WU"};